import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usersApi } from "../../api/usersApi";

export default function UserEdit() {
  const { id } = useParams();
  const nav = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user");

  const [newPass, setNewPass] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const res = await usersApi.get(id);
      setData(res.data);
      setEmail(res.data.email || "");
      const r = (res.data.roles || [])[0] || "user";
      setRole(r);
    } catch (e) {
      alert(e?.response?.data || e.message || "Load failed");
      nav("/users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id]);

  const saveEmail = async () => {
    setSaving(true);
    try {
      await usersApi.update(id, { email });
      await load();
      alert("Saved");
    } catch (e) {
      alert(e?.response?.data || e.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  const saveRole = async () => {
    setSaving(true);
    try {
      await usersApi.setRole(id, { role });
      await load();
      alert("Role updated");
    } catch (e) {
      alert(e?.response?.data || e.message || "Role update failed");
    } finally {
      setSaving(false);
    }
  };

  const resetPassword = async () => {
    if (!newPass.trim()) return alert("New password required");
    if (!window.confirm("Parol sıfırlansın?")) return;

    setSaving(true);
    try {
      await usersApi.resetPassword(id, { newPassword: newPass });
      setNewPass("");
      alert("Password reset OK");
    } catch (e) {
      alert(e?.response?.data || e.message || "Reset failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: 16 }}>Loading...</div>;
  if (!data) return null;

  const isSuperAdmin = (data.roles || []).includes("superadmin");

  return (
    <div style={{ padding: 16, maxWidth: 760, display: "grid", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <h1 style={{ margin: 0 }}>Edit: {data.username}</h1>
        <button className="btn ghost" onClick={() => nav("/users")}>Back</button>
      </div>

      <div className="card" style={{ padding: 16, display: "grid", gap: 12 }}>
        <h3 style={{ margin: 0 }}>Profile</h3>

        <label>
          Username
          <input className="input" value={data.username} disabled />
        </label>

        <label>
          Email
          <input className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>

        <button className="btn" onClick={saveEmail} disabled={saving}>
          Save Email
        </button>
      </div>

      <div className="card" style={{ padding: 16, display: "grid", gap: 12 }}>
        <h3 style={{ margin: 0 }}>Role</h3>

        <label>
          Role
          <select
            className="input"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            disabled={saving || isSuperAdmin} // superadmini dəyişməyə icazə istəmirsənsə
            title={isSuperAdmin ? "Superadmin rolunu dəyişmək bloklanıb" : ""}
          >
            <option value="user">user</option>
            <option value="admin">admin</option>
            <option value="superadmin">superadmin</option>
          </select>
        </label>

        <button className="btn" onClick={saveRole} disabled={saving || isSuperAdmin}>
          Update Role
        </button>
      </div>

      <div className="card" style={{ padding: 16, display: "grid", gap: 12 }}>
        <h3 style={{ margin: 0 }}>Reset Password</h3>

        <label>
          New password
          <input className="input" type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
        </label>

        <button className="btn danger" onClick={resetPassword} disabled={saving}>
          Reset Password
        </button>
      </div>
    </div>
  );
}
